module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "head-text"
  }, [_vm._v("\n\t\t普通投资者：\n\t")]), _vm._v("\n\t普通投资者特定对象确认需要做风险承受能力测评，个人中心也可以重新测评\n\t"), _c('br'), _vm._v("\n\t投资者阅读风险提示，点击“开始测评”可以开始风险测评，预计2-3分钟完成私募基金管理人的测评模板，提交后可查看风险承受能力等级，等级有： "), _c('span', {
    staticClass: "stress-content"
  }, [_vm._v("C1(风险承受能力最低)、C1、C2、C3、C4、C5")]), _vm._v(" "), _c('div', {
    staticClass: "picture"
  }, [_c('van-swipe', {
    ref: "vanswipe",
    attrs: {
      "show-indicators": _vm.showindicators,
      "loop": _vm.loopenable
    },
    on: {
      "change": _vm.onChange
    }
  }, [_c('van-swipe-item', [_c('img', {
    attrs: {
      "src": require("../../common/images/risk_nor1.png"),
      "width": "100%"
    }
  })]), _vm._v(" "), _c('van-swipe-item', [_c('img', {
    attrs: {
      "src": require("../../common/images/risk_nor2.png"),
      "width": "100%"
    }
  })])], 1), _vm._v(" "), _c('my-stepper', {
    attrs: {
      "current_step": _vm.currentStep,
      "total_step": "02"
    },
    on: {
      "leftClick": _vm.leftClick,
      "rightClick": _vm.rightClick
    }
  }, [_vm._v(_vm._s(_vm.message))])], 1), _vm._v(" "), _c('div', {
    staticClass: "head-text"
  }, [_vm._v("\n\t\t专业投资者：\n\t")]), _vm._v("\n\t个人中心可以进行风险承受能力测评 \n\t"), _c('br'), _vm._v("\n\t投资者阅读风险提示，点击“开始测评”可以开始风险测评，预计2-3分钟完成私募基金管理人的测评模板，提交后可查看风险承受能力等级，等级有："), _c('span', {
    staticClass: "stress-content"
  }, [_vm._v("C1(风险承受能力最低)、C1、C2、C3、C4、C5")]), _vm._v(" "), _c('div', {
    staticClass: "picture"
  }, [_c('van-swipe', {
    ref: "vanswipe1",
    attrs: {
      "show-indicators": _vm.showindicators,
      "loop": _vm.loopenable
    },
    on: {
      "change": _vm.onChange1
    }
  }, [_c('van-swipe-item', [_c('img', {
    attrs: {
      "src": require("../../common/images/risk_sp1.png"),
      "width": "100%"
    }
  })]), _vm._v(" "), _c('van-swipe-item', [_c('img', {
    attrs: {
      "src": require("../../common/images/risk_sp2.png"),
      "width": "100%"
    }
  })]), _vm._v(" "), _c('van-swipe-item', [_c('img', {
    attrs: {
      "src": require("../../common/images/risk_sp3.png"),
      "width": "100%"
    }
  })])], 1), _vm._v(" "), _c('my-stepper', {
    attrs: {
      "current_step": _vm.currentStep1,
      "total_step": "03"
    },
    on: {
      "leftClick": _vm.leftClick1,
      "rightClick": _vm.rightClick1
    }
  }, [_vm._v(_vm._s(_vm.message1))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5607f3a8"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Guide/riskGuide.vue
// module id = 1056
// module chunks = 1